<div class="root-container">
    @if (code === 'ERROR_USER_EXPIRED') {
    <h2>
        I'm sorry but your user account is no longer active. Please contact your 11th hour sales representitive for more
        information.
    </h2>
    } @else {
    <h1>Oh No!</h1>
    <h2>
        We have encountered an error, but our engineers have been notified! Please try again later or contact us!
    </h2>
    <div class="container">
        <img src="/assets/images/error.png"  alt="Error Image" class="error-image">
    </div>
    }
</div>